<p-dialog [(visible)]="showDialog" header={{header}} styleClass="quick-view-grid-row venue-details-dialog" 
    [style]="{width: '55%', minWidth: '700px'}" appendTo="body" showEffect="fade" [modal]="true" (onHide)="onClose()">
    @if(isVenueDetailsLoadingResults){
      <div class="example-loading-shade">
        <mat-spinner></mat-spinner>
      </div>
    }
    <form [formGroup]="venueDetailsForm" (ngSubmit)="onSave()">
        <div class="form-panel">
            <div class="row">
                @for (col of columns; track col.mappingkey){
                    @if(col.isFormField == 'true'){
                        <div class="col-12 col-lg-6">
                            <div class="row mb-1 field-wrapper">
                                <div class="col-12 col-md-4">
                                    <label [for]="col.mappingkey">
                                        {{col.ui_columnname}}
                                        @if(col?.isrequired === 'true'){
                                            <span class="required-asterisk">*</span>
                                        }
                                    </label>
                                </div>
                                <div class="col-12 col-md-8">
                                    <div class="form-field-wrapper">
                                        @if(col?.dropdown !== 'YES'){
                                            @if(col?.datatype === 'Boolean') {
                                                <p-toggleswitch [formControlName]="col.mappingkey" [id]="col.mappingkey" styleClass="approveToggleSwitch"></p-toggleswitch>
                                            } @else {
                                                <input
                                                    pInputText
                                                    [maxlength]="col?.maxlength"
                                                    style="width:100%"
                                                    [placeholder]="col?.disabled ? '' : 'Enter Value'"
                                                    [id]="col.mappingkey"
                                                    [formControlName]="col.mappingkey"
                                                    [ngClass]="{'input-error': isFieldInvalid(col.mappingkey)}"
                                                />
                                            }
                                        }
                                        @if(col?.dropdown === 'YES'){
                                            <p-select styleClass="venue-type-dropdown" appendTo="body" required name="destinationTypeDropDown" [id]="col.mappingkey"
                                                [options]="col.dropdownvalue" [ngClass]="{'input-error': isFieldInvalid(col.mappingkey)}"
                                                [style]="{ 'text-transform': 'capitalize', 'width':'100%'}" [formControlName]="col.mappingkey" [placeholder]="venueDetailsService.addRow[col.field]">
                                                <ng-template let-filterCols pTemplate="item">
                                                    <div class="ui-helper-clearfix">
                                                        <div [id]="filterCols.label" [matTooltip]="filterCols?.description" [matTooltipShowDelay]="1000"
                                                            matTooltipPosition="after">
                                                            {{filterCols?.label}}
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-select>
                                        }
                                        @if(getErrorMessage(col)){
                                            <small class="error-message">
                                                {{ getErrorMessage(col) }}
                                            </small>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
        
         @if(mode !== 'view'){
             <div class="mt-3 btn-panel">
                 <div class="col-12 text-end">
                    <p-button type="button" icon="fa fa-close" id="close" 
                        class="venue-details-footer-button"
                        (click) = "onClose()"
                        label="Close">
                    </p-button>

                    <p-button type="submit" icon="fa fa-check" id="save" 
                        class="venue-details-footer-button" 
                        label="Save"
                        [disabled]="venueDetailsService.isLoadingResults">
                            @if(venueDetailsService.isLoadingResults){
                                <i class="pi pi-spin pi-spinner"></i>
                            }
                    </p-button>
                 </div>
             </div>
         }
    </form>
</p-dialog>